import { IRankingColleaguesIn } from "../../models/input/trainingApi/IRankingColleaguesIn";
import * as ApiWithToken from "../callApiWithToken";

const colleaguesService = {
    getRankingColleagues:async function(rankingColleaguesIn: IRankingColleaguesIn){
        return ApiWithToken.postApi(process.env.REACT_APP_COURSES_API + `Colleagues/GetRankingColleagues`, rankingColleaguesIn);
    },
    getRankingColleaguesFilter:async function(){
        return ApiWithToken.getApi(process.env.REACT_APP_COURSES_API + `Colleagues/GetRankingColleaguesFilter`);
    },
}
export default colleaguesService;


